/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { CategoryFragmentDoc } from '../../features/categories/useCategories.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationSettingsOfferedServicesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationSettingsOfferedServicesQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, organisationType: Types.OrganisationType, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null, projectTypeMappings: Array<{ __typename: 'CategoryProjectTypeMapping', categoryId: string, projectType: Types.ProjectType, aiDescription?: string | null, aiContext?: string | null, defaultTemplateId?: string | null, defaultSmartProcess?: string | null }> } }>, categoryProjectTypeMappingOverrides: Array<{ __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null }> } } | null };

export type CategoryProjectTypeMappingFieldsFragment = { __typename: 'CategoryProjectTypeMapping', categoryId: string, projectType: Types.ProjectType, aiDescription?: string | null, aiContext?: string | null, defaultTemplateId?: string | null, defaultSmartProcess?: string | null };

export type OrganisationCategoryProjectTypeMappingOverrideFieldsFragment = { __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null };

export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables = Types.Exact<{
  input: Types.UpsertOrganisationCategoryProjectTypeMappingOverrideInput;
}>;


export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutation = { upsertOrganisationCategoryProjectTypeMappingOverride: { __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null } };

export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationCategoryProjectTypeMappingOverrideInput;
}>;


export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutation = { deleteOrganisationCategoryProjectTypeMappingOverride: { __typename: 'DeleteOrganisationCategoryProjectTypeMappingOverridePayload', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType } };

export type OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables = Types.Exact<{
  templateIds: Array<Types.Scalars['ID']['input']>;
}>;


export type OrganisationSettingsOfferedServices_TemplatesByIdsQuery = { searchTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string } }> } };

export type AddOrganisationOfferedServiceMutationVariables = Types.Exact<{
  input: Types.AddOrganisationOfferedServiceInput;
}>;


export type AddOrganisationOfferedServiceMutation = { addOrganisationOfferedService: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null } }> } } };

export type RemoveOrganisationOfferedServiceMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationOfferedServiceInput;
}>;


export type RemoveOrganisationOfferedServiceMutation = { removeOrganisationOfferedService: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null } }> } } };

export type AddOrganisationCategoryMutationVariables = Types.Exact<{
  input: Types.AddOrganisationCategoryInput;
}>;


export type AddOrganisationCategoryMutation = { addOrganisationCategory: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null } }> } } };

export type RemoveOrganisationCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationCategoryInput;
}>;


export type RemoveOrganisationCategoryMutation = { removeOrganisationCategory: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null } }> } } };

export type SetOrganisationOfferedServicesMutationVariables = Types.Exact<{
  input: Types.SetOrganisationOfferedServicesInput;
}>;


export type SetOrganisationOfferedServicesMutation = { setOrganisationOfferedServices: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', projectType: Types.OfferedProjectType, category: { __typename: 'Category', id: string, parentId?: string | null, rank: number, level: number, name: string, description?: string | null } }> } } };

export const CategoryProjectTypeMappingFieldsFragmentDoc = gql`
    fragment CategoryProjectTypeMappingFields on CategoryProjectTypeMapping {
  categoryId
  projectType
  aiDescription
  aiContext
  defaultTemplateId
  defaultSmartProcess
}
    `;
export const OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc = gql`
    fragment OrganisationCategoryProjectTypeMappingOverrideFields on OrganisationCategoryProjectTypeMappingOverride {
  organisationId
  categoryId
  projectType
  defaultTemplateId
  defaultSmartProcess
}
    `;
export const OrganisationSettingsOfferedServicesDocument = gql`
    query OrganisationSettingsOfferedServices {
  viewer {
    id
    organisation {
      id
      organisationType
      categories
      offeredServices {
        category {
          ...Category
          projectTypeMappings {
            ...CategoryProjectTypeMappingFields
          }
        }
        projectType
      }
      categoryProjectTypeMappingOverrides {
        ...OrganisationCategoryProjectTypeMappingOverrideFields
      }
    }
  }
}
    ${CategoryFragmentDoc}
${CategoryProjectTypeMappingFieldsFragmentDoc}
${OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc}`;

/**
 * __useOrganisationSettingsOfferedServicesQuery__
 *
 * To run a query within a React component, call `useOrganisationSettingsOfferedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationSettingsOfferedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationSettingsOfferedServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationSettingsOfferedServicesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
      }
export function useOrganisationSettingsOfferedServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
        }
export function useOrganisationSettingsOfferedServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
        }
export type OrganisationSettingsOfferedServicesQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesQuery>;
export type OrganisationSettingsOfferedServicesLazyQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesLazyQuery>;
export type OrganisationSettingsOfferedServicesSuspenseQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesSuspenseQuery>;
export type OrganisationSettingsOfferedServicesQueryResult = Apollo.QueryResult<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>;
export const UpsertOrganisationCategoryProjectTypeMappingOverrideDocument = gql`
    mutation UpsertOrganisationCategoryProjectTypeMappingOverride($input: UpsertOrganisationCategoryProjectTypeMappingOverrideInput!) {
  upsertOrganisationCategoryProjectTypeMappingOverride(input: $input) {
    ...OrganisationCategoryProjectTypeMappingOverrideFields
  }
}
    ${OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc}`;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationFn = Apollo.MutationFunction<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;

/**
 * __useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation__
 *
 * To run a mutation, you first call `useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganisationCategoryProjectTypeMappingOverrideMutation, { data, loading, error }] = useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>(UpsertOrganisationCategoryProjectTypeMappingOverrideDocument, options);
      }
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationHookResult = ReturnType<typeof useUpsertOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationResult = Apollo.MutationResult<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type UpsertOrganisationCategoryProjectTypeMappingOverrideMutationOptions = Apollo.BaseMutationOptions<UpsertOrganisationCategoryProjectTypeMappingOverrideMutation, UpsertOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;
export const DeleteOrganisationCategoryProjectTypeMappingOverrideDocument = gql`
    mutation DeleteOrganisationCategoryProjectTypeMappingOverride($input: DeleteOrganisationCategoryProjectTypeMappingOverrideInput!) {
  deleteOrganisationCategoryProjectTypeMappingOverride(input: $input) {
    organisationId
    categoryId
    projectType
  }
}
    `;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationFn = Apollo.MutationFunction<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;

/**
 * __useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationCategoryProjectTypeMappingOverrideMutation, { data, loading, error }] = useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>(DeleteOrganisationCategoryProjectTypeMappingOverrideDocument, options);
      }
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationHookResult = ReturnType<typeof useDeleteOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationResult = Apollo.MutationResult<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation>;
export type DeleteOrganisationCategoryProjectTypeMappingOverrideMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationCategoryProjectTypeMappingOverrideMutation, DeleteOrganisationCategoryProjectTypeMappingOverrideMutationVariables>;
export const OrganisationSettingsOfferedServices_TemplatesByIdsDocument = gql`
    query OrganisationSettingsOfferedServices_TemplatesByIds($templateIds: [ID!]!) {
  searchTemplates(filters: {templateIds: $templateIds}, limit: 100) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          title
        }
      }
    }
  }
}
    `;

/**
 * __useOrganisationSettingsOfferedServices_TemplatesByIdsQuery__
 *
 * To run a query within a React component, call `useOrganisationSettingsOfferedServices_TemplatesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationSettingsOfferedServices_TemplatesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationSettingsOfferedServices_TemplatesByIdsQuery({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useOrganisationSettingsOfferedServices_TemplatesByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables> & ({ variables: OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>(OrganisationSettingsOfferedServices_TemplatesByIdsDocument, options);
      }
export function useOrganisationSettingsOfferedServices_TemplatesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>(OrganisationSettingsOfferedServices_TemplatesByIdsDocument, options);
        }
export function useOrganisationSettingsOfferedServices_TemplatesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>(OrganisationSettingsOfferedServices_TemplatesByIdsDocument, options);
        }
export type OrganisationSettingsOfferedServices_TemplatesByIdsQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServices_TemplatesByIdsQuery>;
export type OrganisationSettingsOfferedServices_TemplatesByIdsLazyQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServices_TemplatesByIdsLazyQuery>;
export type OrganisationSettingsOfferedServices_TemplatesByIdsSuspenseQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServices_TemplatesByIdsSuspenseQuery>;
export type OrganisationSettingsOfferedServices_TemplatesByIdsQueryResult = Apollo.QueryResult<OrganisationSettingsOfferedServices_TemplatesByIdsQuery, OrganisationSettingsOfferedServices_TemplatesByIdsQueryVariables>;
export const AddOrganisationOfferedServiceDocument = gql`
    mutation AddOrganisationOfferedService($input: AddOrganisationOfferedServiceInput!) {
  addOrganisationOfferedService(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        category {
          ...Category
        }
        projectType
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type AddOrganisationOfferedServiceMutationFn = Apollo.MutationFunction<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>;

/**
 * __useAddOrganisationOfferedServiceMutation__
 *
 * To run a mutation, you first call `useAddOrganisationOfferedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationOfferedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationOfferedServiceMutation, { data, loading, error }] = useAddOrganisationOfferedServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganisationOfferedServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>(AddOrganisationOfferedServiceDocument, options);
      }
export type AddOrganisationOfferedServiceMutationHookResult = ReturnType<typeof useAddOrganisationOfferedServiceMutation>;
export type AddOrganisationOfferedServiceMutationResult = Apollo.MutationResult<AddOrganisationOfferedServiceMutation>;
export type AddOrganisationOfferedServiceMutationOptions = Apollo.BaseMutationOptions<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>;
export const RemoveOrganisationOfferedServiceDocument = gql`
    mutation RemoveOrganisationOfferedService($input: RemoveOrganisationOfferedServiceInput!) {
  removeOrganisationOfferedService(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        category {
          ...Category
        }
        projectType
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type RemoveOrganisationOfferedServiceMutationFn = Apollo.MutationFunction<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>;

/**
 * __useRemoveOrganisationOfferedServiceMutation__
 *
 * To run a mutation, you first call `useRemoveOrganisationOfferedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganisationOfferedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganisationOfferedServiceMutation, { data, loading, error }] = useRemoveOrganisationOfferedServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganisationOfferedServiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>(RemoveOrganisationOfferedServiceDocument, options);
      }
export type RemoveOrganisationOfferedServiceMutationHookResult = ReturnType<typeof useRemoveOrganisationOfferedServiceMutation>;
export type RemoveOrganisationOfferedServiceMutationResult = Apollo.MutationResult<RemoveOrganisationOfferedServiceMutation>;
export type RemoveOrganisationOfferedServiceMutationOptions = Apollo.BaseMutationOptions<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>;
export const AddOrganisationCategoryDocument = gql`
    mutation AddOrganisationCategory($input: AddOrganisationCategoryInput!) {
  addOrganisationCategory(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        category {
          ...Category
        }
        projectType
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type AddOrganisationCategoryMutationFn = Apollo.MutationFunction<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>;

/**
 * __useAddOrganisationCategoryMutation__
 *
 * To run a mutation, you first call `useAddOrganisationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationCategoryMutation, { data, loading, error }] = useAddOrganisationCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganisationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>(AddOrganisationCategoryDocument, options);
      }
export type AddOrganisationCategoryMutationHookResult = ReturnType<typeof useAddOrganisationCategoryMutation>;
export type AddOrganisationCategoryMutationResult = Apollo.MutationResult<AddOrganisationCategoryMutation>;
export type AddOrganisationCategoryMutationOptions = Apollo.BaseMutationOptions<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>;
export const RemoveOrganisationCategoryDocument = gql`
    mutation RemoveOrganisationCategory($input: RemoveOrganisationCategoryInput!) {
  removeOrganisationCategory(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        category {
          ...Category
        }
        projectType
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type RemoveOrganisationCategoryMutationFn = Apollo.MutationFunction<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>;

/**
 * __useRemoveOrganisationCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveOrganisationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganisationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganisationCategoryMutation, { data, loading, error }] = useRemoveOrganisationCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganisationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>(RemoveOrganisationCategoryDocument, options);
      }
export type RemoveOrganisationCategoryMutationHookResult = ReturnType<typeof useRemoveOrganisationCategoryMutation>;
export type RemoveOrganisationCategoryMutationResult = Apollo.MutationResult<RemoveOrganisationCategoryMutation>;
export type RemoveOrganisationCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>;
export const SetOrganisationOfferedServicesDocument = gql`
    mutation SetOrganisationOfferedServices($input: SetOrganisationOfferedServicesInput!) {
  setOrganisationOfferedServices(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        category {
          ...Category
        }
        projectType
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type SetOrganisationOfferedServicesMutationFn = Apollo.MutationFunction<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>;

/**
 * __useSetOrganisationOfferedServicesMutation__
 *
 * To run a mutation, you first call `useSetOrganisationOfferedServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganisationOfferedServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganisationOfferedServicesMutation, { data, loading, error }] = useSetOrganisationOfferedServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganisationOfferedServicesMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>(SetOrganisationOfferedServicesDocument, options);
      }
export type SetOrganisationOfferedServicesMutationHookResult = ReturnType<typeof useSetOrganisationOfferedServicesMutation>;
export type SetOrganisationOfferedServicesMutationResult = Apollo.MutationResult<SetOrganisationOfferedServicesMutation>;
export type SetOrganisationOfferedServicesMutationOptions = Apollo.BaseMutationOptions<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>;